import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TfDropdownComponent} from './tf-dropdown/tf-dropdown.component';
import {
  TfMultiSelectDropdownComponent
} from './tf-multi-select-dropdown/tf-multi-select-dropdown.component';
import {VirtualScrollerModule} from "ngx-virtual-scroller";
import {TfCheckboxModule} from "@app/modules/tf-checkbox";
import {FormsModule} from "@angular/forms";
import {TfInputFieldsModule} from "@app/modules/tf-input-fields";
import {TfDropdownService} from "./tf-drop-down.service";


@NgModule({
  declarations: [TfDropdownComponent, TfMultiSelectDropdownComponent],
  imports: [CommonModule, TfCheckboxModule, FormsModule, TfInputFieldsModule, VirtualScrollerModule],
  exports: [TfDropdownComponent, TfMultiSelectDropdownComponent],
  providers: [TfDropdownService]
})
export class TfDropdownsModule { }
